import { Credentials } from "@fairfleet/geotab";
import { ReactNode, useEffect, useState } from "react";
import { useGeotabClient } from "./GeotabClientContext";
import { LoginPage } from "./login/LoginPage";

interface Props {
  children: ReactNode;
}

/**
 * Component that renders a login page if the user is not logged in.
 *
 * @remarks This component is only used in development mode.
 */
export function AuthBoundary({ children }: Props) {
  //const credentialsJson = localStorage.getItem(LocalStorageItems.addinSession);
  const { sessions, isLoading } = useGeotabClient();
  const [isLoggedIn, setIsLoggedIn] = useState(sessions.length > 0);
  useEffect(() => {
    setIsLoggedIn(sessions.length > 0);
  }, [sessions]);
  function onLoggedIn(_credentials: Credentials) {
    setIsLoggedIn(true);
    //localStorage.setItem(LocalStorageItems.addinSession, JSON.stringify(credentials));
  }
  if (isLoading) return <></>;

  if (!isLoggedIn) {
    return <LoginPage onLoggedIn={onLoggedIn} />;
  }

  /*  globalThis.geotabClient = createGeotab({
    credentials: JSON.parse(credentialsJson),
  }); */

  return children;
}
